<div class="quote-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-12 sm:py-20 lg:py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-3xl">
        <h1 class="text-4xl sm:text-5xl font-bold mb-3 sm:mb-4">Get a Property Quote</h1>
        <p class="text-base sm:text-xl text-blue-100 leading-relaxed">Tell us about your dream property and we'll provide you with tailored options and professional guidance.</p>
      </div>
    </div>
  </section>

  <div class="max-w-5xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-xl shadow-2xl overflow-hidden">
      <!-- Form Header -->
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 sm:px-8 py-6 border-b-2 border-indigo-200">
        <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3">
          <svg class="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          Request Your Quote
        </h2>
        <p class="text-gray-600 mt-2">Fill out the form below and our team will get back to you within 24 hours</p>
      </div>

      <form (ngSubmit)="submitForm()" class="px-6 sm:px-8 py-8 space-y-6">
        <!-- Personal Information Section -->
        <div class="space-y-6">
          <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
            <svg class="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
            </svg>
            Personal Information
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <!-- Name -->
            <div>
              <label for="name" class="block text-sm font-semibold text-gray-900 mb-2">
                Full Name <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                [(ngModel)]="name"
                name="name"
                placeholder="Nadia Habib"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['name'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['name']" class="text-sm text-red-600 mt-1">{{ errors()['name'] }}</p>
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-semibold text-gray-900 mb-2">
                Email Address <span class="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                [(ngModel)]="email"
                name="name"
                placeholder="nadia@example.com"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['email'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['email']" class="text-sm text-red-600 mt-1">{{ errors()['email'] }}</p>
            </div>
          </div>

          <!-- Phone -->
          <div class="grid grid-cols-3 gap-3 sm:gap-4">
            <div>
              <label for="country_code" class="block text-sm font-semibold text-gray-900 mb-2">
                Code <span class="text-red-500">*</span>
              </label>
              <select
                id="country_code"
                [(ngModel)]="country_code"
                name="country_code"
                [class]="'w-full px-3 sm:px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['country_code'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              >
                <option *ngFor="let country of countryCodes" [value]="country.code">
                  {{ country.flag }} {{ country.code }}
                </option>
              </select>
              <p *ngIf="errors()['country_code']" class="text-xs text-red-600 mt-1">{{ errors()['country_code'] }}</p>
            </div>

            <div class="col-span-2">
              <label for="phone" class="block text-sm font-semibold text-gray-900 mb-2">
                Phone Number <span class="text-red-500">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                [(ngModel)]="phone"
                name="phone"
                placeholder="76-987-654"
                [class]="'w-full px-3 sm:px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['phone'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['phone']" class="text-xs text-red-600 mt-1">{{ errors()['phone'] }}</p>
            </div>
          </div>
        </div>

        <!-- Property Requirements Section -->
        <div class="space-y-6 pt-6 border-t-2 border-gray-100">
          <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
            <svg class="w-5 h-5 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            Property Requirements
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            <!-- Property Type -->
            <div>
              <label for="propertyType" class="block text-sm font-semibold text-gray-900 mb-2">
                Property Type <span class="text-red-500">*</span>
              </label>
              <select
                id="propertyType"
                [(ngModel)]="propertyType"
                name="propertyType"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['propertyType'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              >
                <option value="">Select property type...</option>
                <option value="Apartment">🏢 Apartment</option>
                <option value="Villa">🏡 Villa</option>
                <option value="Land">🌳 Land</option>
                <optgroup label="🏪 Commercial">
                  <option value="Commercial - Office">📋 Office</option>
                  <option value="Commercial - Warehouse">📦 Warehouse</option>
                  <option value="Commercial - Shop">🛍️ Shop</option>
                  <option value="Commercial - Industrial Land">🏭 Industrial Land</option>
                  <option value="Commercial - Building">🏢 Building</option>
                  <option value="Commercial - Showroom">🎪 Showroom</option>
                </optgroup>
              </select>
              <p *ngIf="errors()['propertyType']" class="text-sm text-red-600 mt-1">{{ errors()['propertyType'] }}</p>
            </div>

            <!-- Budget -->
            <div>
              <label for="budget" class="block text-sm font-semibold text-gray-900 mb-2">
                Budget Range <span class="text-red-500">*</span>
              </label>
              <select
                id="budget"
                [(ngModel)]="budget"
                name="budget"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['budget'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              >
                <option value="">Select budget range...</option>
                <option value="Under €100,000">Under €100,000</option>
                <option value="€100,000 - €250,000">€100,000 - €250,000</option>
                <option value="€250,000 - €500,000">€250,000 - €500,000</option>
                <option value="€500,000 - €1,000,000">€500,000 - €1,000,000</option>
                <option value="€1,000,000 - €2,000,000">€1,000,000 - €2,000,000</option>
                <option value="Above €2,000,000">Above €2,000,000</option>
              </select>
              <p *ngIf="errors()['budget']" class="text-sm text-red-600 mt-1">{{ errors()['budget'] }}</p>
            </div>

            <!-- Location -->
            <div class="md:col-span-2">
              <label for="location" class="block text-sm font-semibold text-gray-900 mb-2">
                Preferred Location <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="location"
                [(ngModel)]="location"
                name="location"
                placeholder="Achrafieh, Verdun, Hamra, etc."
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition ' + (errors()['location'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['location']" class="text-sm text-red-600 mt-1">{{ errors()['location'] }}</p>
            </div>

            <!-- Bedrooms -->
            <div>
              <label for="bedrooms" class="block text-sm font-semibold text-gray-900 mb-2">
                Bedrooms
              </label>
              <select
                id="bedrooms"
                [(ngModel)]="bedrooms"
                name="bedrooms"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              >
                <option value="">Any</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5+">5+</option>
              </select>
            </div>

            <!-- Bathrooms -->
            <div>
              <label for="bathrooms" class="block text-sm font-semibold text-gray-900 mb-2">
                Bathrooms
              </label>
              <select
                id="bathrooms"
                [(ngModel)]="bathrooms"
                name="bathrooms"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              >
                <option value="">Any</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5+">5+</option>
              </select>
            </div>

            <!-- Neighborhood -->
            <div>
              <label for="neighborhood" class="block text-sm font-semibold text-gray-900 mb-2">
                Neighborhood
              </label>
              <input
                type="text"
                id="neighborhood"
                [(ngModel)]="neighborhood"
                name="neighborhood"
                placeholder="Downtown, Seaside, etc."
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              />
            </div>

            <!-- Floor -->
            <div>
              <label for="floor" class="block text-sm font-semibold text-gray-900 mb-2">
                Floor
              </label>
              <input
                type="text"
                id="floor"
                [(ngModel)]="floor"
                name="floor"
                placeholder="1st, 2nd, Ground, etc."
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              />
            </div>

            <!-- Parking Covered -->
            <div>
              <label for="parkingCovered" class="block text-sm font-semibold text-gray-900 mb-2">
                Covered Parking Spots
              </label>
              <input
                type="number"
                id="parkingCovered"
                [(ngModel)]="parkingCovered"
                name="parkingCovered"
                placeholder="0"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              />
            </div>

            <!-- Parking Outdoor -->
            <div>
              <label for="parkingOutdoor" class="block text-sm font-semibold text-gray-900 mb-2">
                Outdoor Parking Spots
              </label>
              <input
                type="number"
                id="parkingOutdoor"
                [(ngModel)]="parkingOutdoor"
                name="parkingOutdoor"
                placeholder="0"
                min="0"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              />
            </div>

            <!-- General Condition -->
            <div class="md:col-span-2">
              <label for="generalCondition" class="block text-sm font-semibold text-gray-900 mb-2">
                General Condition
              </label>
              <select
                id="generalCondition"
                [(ngModel)]="generalCondition"
                name="generalCondition"
                class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white"
              >
                <option value="">Any</option>
                <option value="excellent">Excellent</option>
                <option value="good">Good</option>
                <option value="fair">Fair</option>
                <option value="needs_work">Needs Work</option>
                <option value="renovation_required">Renovation Required</option>
              </select>
            </div>
          </div>

          <!-- Property Features Checkboxes -->
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4 pt-4">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="hasElevator"
                name="hasElevator"
                class="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition">Elevator</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="hasTerrace"
                name="hasTerrace"
                class="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition">Terrace</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="hasGarden"
                name="hasGarden"
                class="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition">Garden</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="hasView"
                name="hasView"
                class="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition">View</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="isFurnished"
                name="isFurnished"
                class="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-600 transition">Furnished</span>
            </label>
          </div>
        </div>

        <!-- Additional Details -->
        <div class="space-y-4 pt-6 border-t-2 border-gray-100">
          <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2 pb-2 border-b-2 border-gray-200">
            <svg class="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
            </svg>
            Additional Details
          </h3>

          <div>
            <label for="message" class="block text-sm font-semibold text-gray-900 mb-2">
              Tell us more about what you're looking for
            </label>
            <textarea
              id="message"
              [(ngModel)]="message"
              name="message"
              rows="5"
              placeholder="Any specific requirements, features you're looking for, or questions you have..."
              class="w-full px-3 py-2 sm:py-2.5 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-gray-50 hover:bg-white resize-none"
            ></textarea>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="pt-6 border-t-2 border-gray-100">
          <button
            type="submit"
            [disabled]="isSubmitting()"
            [class]="isSubmitting() 
              ? 'w-full bg-gray-400 cursor-not-allowed' 
              : 'w-full bg-gradient-to-r from-immovea-navy to-blue-700 hover:from-blue-900 hover:to-blue-800 transform hover:scale-[1.02]'"
            class="text-white px-8 py-4 rounded-xl font-bold text-lg shadow-xl transition-all flex items-center justify-center gap-3"
          >
            <svg *ngIf="!isSubmitting()" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
            </svg>
            <svg *ngIf="isSubmitting()" class="animate-spin w-6 h-6" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isSubmitting() ? 'Submitting...' : 'Request Quote' }}
          </button>
          <p class="text-sm text-gray-500 text-center mt-4">We'll review your requirements and get back to you within 24 hours</p>
        </div>
      </form>
    </div>

    <!-- Info Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
      <div class="bg-white rounded-xl p-6 shadow-md text-center">
        <div class="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-7 h-7 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <h3 class="font-bold text-gray-900 mb-2">Quick Response</h3>
        <p class="text-sm text-gray-600">We respond to all quote requests within 24 hours</p>
      </div>

      <div class="bg-white rounded-xl p-6 shadow-md text-center">
        <div class="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-7 h-7 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <h3 class="font-bold text-gray-900 mb-2">Expert Guidance</h3>
        <p class="text-sm text-gray-600">Professional advice tailored to your needs</p>
      </div>

      <div class="bg-white rounded-xl p-6 shadow-md text-center">
        <div class="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-7 h-7 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
        </div>
        <h3 class="font-bold text-gray-900 mb-2">Confidential</h3>
        <p class="text-sm text-gray-600">Your information is secure and private</p>
      </div>
    </div>
  </div>
</div>
